import React, { useEffect, useState } from "react";
import SaturationComponent from "./Saturation";
import Hue from "./Hue";
import ColorPalette from "./ColorPalette";
import TransparencySlider from "./TransparencySlider";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { useDispatch, useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import PropTypes from "prop-types";

const ColorPicker = ({ defaultColor, syncColor, shapeType, isForFill }) => {
	const [color, setColor] = useState("");
	const dispatch = useDispatch();
	const dir = useSelector((state) => getDir(state));

	useEffect(() => {
		setColor(defaultColor);
	}, [defaultColor]);

	const handleChange = (newColor) => {
		if (newColor?.hex) {
			setColor(newColor.hex);
			syncColor(newColor.hex);
			if (isForFill) {
				dispatch(createOrUpdateShape(shapeType, { polyFill: newColor.hex }));
			} else {
				dispatch(createOrUpdateShape(shapeType, { polyStroke: newColor.hex }));
			}
		} else {
			setColor(newColor);
			syncColor(newColor);
			if (isForFill) {
				dispatch(createOrUpdateShape(shapeType, { polyFill: newColor }));
			} else {
				dispatch(createOrUpdateShape(shapeType, { polyStroke: newColor }));
			}
		}
	};

	return (
		<div style={{ backgroundColor: "#25272B", height: "auto" }}>
			<div>
				<div style={{ display: "flex", marginBottom: 10, marginTop: 16.25 }}>
					<div
						style={{
							width: 222,
							height: 109.25,
							position: "relative",
							...(dir === "ltr" && { marginLeft: 16.37 }),
							...(dir === "rtl" && { marginRight: 16.37 })
						}}
					>
						<SaturationComponent color={color} onChange={handleChange} data-testid="orion-components-shared-components-shape-editor-components-shared-color-picker-color-picker-saturation-component" />
					</div>
					<div
						style={{
							width: 14,
							height: 109.25,
							position: "relative",
							...(dir === "ltr" && { marginLeft: 15.05 }),
							...(dir === "rtl" && { marginRight: 15.05 })
						}}
					>
						<Hue syncColor={handleChange} />
					</div>
				</div>
				<div
					style={{
						width: 254,
						height: 50,
						...(dir === "ltr" && { marginLeft: 16.37 }),
						...(dir === "rtl" && { marginRight: 16.37 })
					}}
				>
					<ColorPalette syncColor={handleChange} defaultColor={defaultColor} />
				</div>
			</div>
			<div
				style={{
					marginTop: 35,
					...(dir === "ltr" && { marginLeft: 25 }),
					...(dir === "rtl" && { marginRight: 25 }),
					width: 215,
					backgroundColor: "#25272B"
				}}
			>
				<TransparencySlider shapeType={shapeType} isForFill={isForFill} />
			</div>
		</div>
	);
};

ColorPicker.propTypes = {
	defaultColor: PropTypes.string.isRequired,
	syncColor: PropTypes.func.isRequired,
	shapeType: PropTypes.string.isRequired,
	isForFill: PropTypes.bool.isRequired
};

export default ColorPicker;
